import type { IProperty } from "@/api/admin/branches/types";
import { AttributeBranchType } from "@/api/admin/types";

export const getCuisineIdsFromBrandProperties = (
  properties?: IProperty[]
): string[] =>
  (properties ?? [])
    .filter(item => item.type === AttributeBranchType.CUISINE)
    .map(item => item.id);

export const mergeBrandPropertiesWithCuisine = (
  properties: IProperty[] | undefined,
  cuisineIds: string[]
): string[] => {
  const otherPropertyIds = (properties ?? [])
    .filter(item => item.type !== AttributeBranchType.CUISINE)
    .map(item => item.id);

  return [...otherPropertyIds, ...cuisineIds];
};
